import React from "react";
import MediaQuery from "react-responsive";
import MobileLayoutContainer from "../containers/MobileLayoutContainer";
import DesktopLayout from "../DesktopLayout";
import "../styles/css/index.css";
import "antd/dist/antd.css";

const AsyncApp = () => {
  return (
    <div className="AsyncApp">
      <MediaQuery maxWidth={991}>
        <MobileLayoutContainer />
      </MediaQuery>
      <MediaQuery minWidth={992}>
        <DesktopLayout />
      </MediaQuery>
    </div>
  );
};

AsyncApp.propTypes = {
  // selectedSubreddit: PropTypes.string.isRequired,
  // posts: PropTypes.array.isRequired,
  // isFetching: PropTypes.bool.isRequired,
  // lastUpdated: PropTypes.number,
  // dispatch: PropTypes.func.isRequired
};

export default AsyncApp;



// WEBPACK FOOTER //
// ./src/containers/AsyncApp.js